import { Container, Button } from "react-bootstrap";
import CustomPagination from "Component/common/CustomPagination";
import TableLayout from "Component/common/TableLayout";
import TableProfile from "Component/common/TableLayout/TableProfile";
import TableStatusOptionsAction from "Component/common/TableStatusOptionsAction";
import { userStatusOptionArr } from "utilities/const";
import { MANAGE_USER } from "services/ApiCalls";
import { removeUnderScore } from "utilities/utilities";
import { useNavigate } from "react-router-dom";

import TableActions from "Component/common/TableActions";

const Pendingtable = ({
  data,
  total,
  body,
  setBody,
  paginationHandler,
  loader,
  statusChangeHandler,
}) => {
  const navigate = useNavigate();

  const col = [
    {
      head: "Picture",
      accessor: "email",
      component: (item) => <TableProfile image={item?.profileImage} />,
    },
    {
      head: "Name",
      accessor: "",
      component: (item) => (
        <>
          {item?.fname} {item?.lname}
        </>
      ),
    },
    {
      head: "Phone",
      accessor: "email",

      component: (item) => (
        <>{item?.mobileNumber ? "+" + item?.mobileNumber : ""}</>
      ),
    },
    {
      head: "Email",
      accessor: "email",
    },
    {
      head: "User Type",
      accessor: "accountType",
      component: (item) => <>{removeUnderScore(item?.accountType)}</>,
    },
    {
      head: "Request Type",
      accessor: "changeRole",
      component: (item) => <>{removeUnderScore(item?.changeRole)}</>,
    },
    {
      head: "Status",
      accessor: "accountType",
      component: (item, index) => (
        <TableStatusOptionsAction
          onChange={(userStatus, reason) => {
            statusChangeHandler(
              () =>
                MANAGE_USER(
                  reason
                    ? {
                        ...reason,
                        _id: item?._id,
                        // userStatus,
                        changeRoleRequest:
                          userStatus === "decline" ? "yes" : "no",
                        userStatus,
                      }
                    : {
                        _id: item?._id,
                        // userStatus,
                        changeRoleRequest:
                          userStatus === "decline" ? "yes" : "no",
                        // changeRole: item?.changeRole || item?.role,
                        userStatus,
                      }
                ),
              index,
              "userStatus",
              userStatus,
              true
            );
          }}
          statusOptionArr={userStatusOptionArr}
          value={item?.changeRoleRequestStatus}
          showRejectModel={true}
        />
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "",
    //   component: (item) => <TableActions viewLink={`/user-view/${item._id}`} />,
    // },
  ];
  return (
    <section className="Diagnosis_table com_table ">
      <Container>
        <TableLayout data={data} column={col} loader={loader} body={body} />
        <div className="pagination_list d-flex align-items-center gap-3 justify-content-end py-3">
          <CustomPagination
            total={total}
            body={body}
            setBody={setBody}
            pageChangeHandler={paginationHandler}
          />
        </div>
      </Container>
    </section>
  );
};

export default Pendingtable;
